var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"checkbox"},[_c('input',{attrs:{"id":_vm.id,"type":"checkbox"},domProps:{"checked":_vm.valCheckbox},on:{"click":function($event){return _vm.$emit('click', $event.target.value)}}}),_c('label',{attrs:{"for":_vm.id}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }